<template>
  <div
    class="tw:flex tw:justify-between tw:bg-[#000] tw:px-8 tw:pt-[12px] tw:pb-[57px] tw:w-full tw:max-w-[430px]"
  >
    <div>
      <Button variant="text" rounded aria-label="Home" class="tw:bg-transparent hover:tw:bg-transparent focus:tw:bg-transparent active:tw:bg-transparent">
        <Image src="/images/icons/home.svg" alt="Home" />
      </Button>
    </div>
    <div>
      <Button variant="text" rounded aria-label="Medication" @click="navigate('/savanne')" class="tw:bg-transparent hover:tw:bg-transparent focus:tw:bg-transparent active:tw:bg-transparent">
        <div class="tw:flex tw:flex-col tw:items-center">
          <Image :src="isNavigatorActive ? '/images/icons/savanne-filled.svg' : '/images/icons/savanne.svg'" alt="Navigator" />
          <div v-show="isNavigatorActive" class="tw:mt-1 tw:h-[2px] tw:w-[16px] tw:bg-[#CECECE] tw:rounded-[12px]"></div>
        </div>
      </Button>
    </div>
    <div>
      <Button variant="text" rounded aria-label="Medication" @click="navigate('/haven')" class="tw:bg-transparent hover:tw:bg-transparent focus:tw:bg-transparent active:tw:bg-transparent">
        <div class="tw:flex tw:flex-col tw:items-center">
          <Image :src="isMedicationActive ? '/images/icons/haven-filled.svg' : '/images/icons/haven.svg'" alt="Medication" />
          <div v-show="isMedicationActive" class="tw:mt-1 tw:h-[2px] tw:w-[16px] tw:bg-[#CECECE] tw:rounded-[12px]"></div>
        </div>
      </Button>
    </div>
    <div>
      <Button variant="text" rounded aria-label="Tracker" @click="navigate('/vigilant')" class="tw:bg-transparent hover:tw:bg-transparent focus:tw:bg-transparent active:tw:bg-transparent">
        <div class="tw:flex tw:flex-col tw:items-center">
          <Image :src="isTrackerActive ? '/images/icons/vigilant-filled.svg' : '/images/icons/vigilant.svg'" alt="Tracker" />
          <div v-show="isTrackerActive" class="tw:mt-1 tw:h-[2px] tw:w-[16px] tw:bg-[#CECECE] tw:rounded-[12px]"></div>
        </div>
      </Button>
    </div>
    <div class="tw:-mt-1">
      <Button variant="text" rounded aria-label="Account" class="tw:bg-transparent hover:tw:bg-transparent focus:tw:bg-transparent active:tw:bg-transparent">
        <Avatar :image="avatarUrl" shape="circle" class="tw:size-9" />
      </Button>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth-store';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';

const { ME } = storeToRefs(useAuthStore());
const router = useRouter();
const route = useRoute();

const avatarUrl = computed(() => ME.value?.avatar || '/images/avatars/profile.png');

const isMedicationActive = computed(() => route.path.startsWith('/haven'));
const isTrackerActive = computed(() => route.path.startsWith('/vigilant'));
const isNavigatorActive = computed(() => route.path.startsWith('/savanne'));

const navigate = (path) => {
 router.push(path)
}
</script>
